import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ActivityItem = ({ checked, disabled, onChange, title, description, noOfOpenSpots, noOfParticipants }) => {
    return (
        <div className='d-flex w-100'>
            <Checkbox
                sx={{
                    padding: 0,
                }}
                checked={checked}
                disabled={disabled}
                onChange={onChange}
                inputProps={{ 'aria-label': 'controlled' }}
            />
            <div className='w-100 ml-2'>
                <Accordion sx={{ width: 'inherit' }} >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="activity-content"
                        id="activity-header"
                    >
                        <div>
                            <Typography><b>{title}</b> <i>{noOfOpenSpots === 0 ? 'FULLBOKAD' : ''} {noOfOpenSpots !== 0 && noOfOpenSpots < noOfParticipants ? `Enbart plats för ${noOfOpenSpots} personer` : ''}</i></Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            {description !== null && description.length > 0 ? description : "Information/beskrivning saknas för aktiviteten"}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
}

export default ActivityItem